<template>
  <v-menu left
          bottom>
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            height="38px"
            width="38px"
            v-on="{ ...tooltip, ...menu }"
          >
            <v-icon color="white" size="22px">
              feather-settings
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('sidebar.configure') }}</span>
      </v-tooltip>
    </template>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-list color="kbLight">
          <v-list-item v-for="(subItem, ind) in menuItems"
                      :key="`subItem-${ind}`"
                      @click="subItem.itemFunction()">
            <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">
                {{ subItem.name }}
            </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-menu>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp
    }),
    ...mapGetters(['administratorRoles', 'isAdmin', 'isSuperAdmin', 'userType', 'businessModule', 'appUuid', 'companyUuid', 'isAdmin', 'isSuperAdmin']),
    menuItems () {
      const selectedCompanyUuid = this.selectedCompany.UUID
      const selectedAppUuid = this.selectedApp.UUID
      const vue = this
      return [
        {
          name: this.$t('sidebar.generalities'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'Configuracion' }) },
          pathName: 'Configuracion'
        },
        {
          name: this.$t('sidebar.apps'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'Detalles', params: { companyid: selectedCompanyUuid, appid: selectedAppUuid } }) },
          pathName: 'Detalles'
        },
        {
          name: this.$t('sidebar.administrators'),
          shownCondition: this.appUuid && (this.isSuperAdmin || this.isAdmin),
          itemFunction () { vue.goto({ name: 'Administradores', params: { companyid: selectedCompanyUuid, appid: selectedAppUuid } }) },
          pathName: 'Administradores'
        },
        {
          name: this.$t('sidebar.billing'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'DailyUsage' }) },
          pathName: 'DailyUsage'
        },
        {
          name: this.$t('sidebar.conversationSettings'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'ConversationSettings' }) },
          pathName: 'ConversationSettings'
        },
        {
          name: this.$t('sidebar.emailSettings'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'EmailSettings' }) },
          pathName: 'EmailSettings'
        },
        {
          name: this.$t('sidebar.graphicAspect'),
          shownCondition: this.appUuid && (this.isSuperAdmin || this.isAdmin),
          itemFunction () { vue.goto({ name: 'Graphic Aspect', params: { appid: selectedAppUuid } }) }
        },
        {
          name: this.$t('sidebar.roles'),
          shownCondition: this.appUuid,
          itemFunction () { vue.goto({ name: 'Roles', params: { appid: selectedAppUuid } }) },
          pathName: 'Roles'
        },
        {
          name: this.$t('general.journey'),
          shownCondition: true,
          itemFunction () { vue.goto({ name: 'journey', params: { companyid: selectedCompanyUuid, appid: selectedAppUuid } }) },
          pathName: 'journey'
        }
      ]
    }
  },
  methods: {
    goto (route) {
      if (route.name && route.name === this.$route.name) return
      this.$router.push(route)
    }
  }
}
</script>
